import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { BaseButtonSizeEnum } from '../../components/base-button/base-button-size.enum';
import { Employer } from '../../../../models/employers/employer';
import { AddressUtils } from '../../../../utils/address-utils';

@Component({
  selector: 'app-employer-record-addresses-card',
  templateUrl: './employer-record-addresses-card.component.html',
  styleUrls: ['./employer-record-addresses-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordAddressesCardComponent implements OnChanges {
  @Input({ required: true }) employer!: Employer;
  @Input({ required: true }) isLoading!: boolean;
  @Output() editClicked = new EventEmitter<void>();

  public mailingAddressSameAsHeadOffice = false;

  public ngOnChanges(): void {
    const headOffice = this.employer?.headOfficeAddress;
    const mailing = this.employer?.mailingAddress;
    this.mailingAddressSameAsHeadOffice =
      !mailing || !headOffice || AddressUtils.areAddressesEqual(headOffice, mailing, true);
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
